import styles from "./Post.module.scss";
import Image from "next/image";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { useAppContext } from "@/context/AppContext";
import { InstagramPost } from "@/wp/getInstagram";
import { useState } from "react";

interface PostProps {
  post: InstagramPost;
  show_border_radius: boolean;
  show_box_shadow: boolean;
  show_card_box: boolean;
  skeleton?: boolean;
  postSizes: string;
  modalAnimation: boolean;
}

export const Post = ({
  post,
  show_border_radius,
  show_box_shadow,
  show_card_box,
  skeleton: skeletonProps,
  postSizes,
  modalAnimation,
}: PostProps) => {
  const { setInstagramPostModal } = useAppContext();
  const { getLabel } = useGlobalContext();

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const imageSrc =
    post.media_type == "video" ? (post.thumbnail_url ?? "") : post.media_url;

  const skeleton = skeletonProps || isLoading;
  return (
    <button
      onClick={() => {
        if (skeleton) return;
        setInstagramPostModal({ post, animated: modalAnimation });
      }}
      className={`${styles["post-button"]} ${skeleton ? "skeleton-element" : ""}`}
      aria-label={`${getLabel("open_project", "Öffne")} Modal ${post.caption ?? ""}`.trim()}
    >
      <div
        className={` ${show_card_box ? "is-box" : ""} ${show_border_radius && show_card_box ? "has-border-radius" : ""} ${show_box_shadow && show_card_box ? "has-box-shadow" : ""}`}
      >
        {imageSrc ? (
          <Image
            src={imageSrc}
            alt={post.alt_text ?? ""}
            width={200}
            height={200}
            quality={90}
            sizes={postSizes}
            onLoad={() => {
              if (!imageSrc) return; // do not setIsLoading to true in placeholder mode
              setIsLoading(false);
            }}
          />
        ) : (
          // eslint-disable-next-line jsx-a11y/alt-text
          <img />
        )}
      </div>
    </button>
  );
};
